import React, { useEffect, useRef, useState } from 'react';
import {
  Wrapper,
  Dots,
  Overlay,
  OverLayContent,
  PageNumber,
  TOCContainer,
  TOCItem,
} from './styles';
import { withTranslation } from 'react-i18next';
import { COMPLEX_PAGE_OPTIONS } from '../../containers/ComplexDocumentDesign/translationValues';

const NAMESPACES = ['COMPLEX_PAGE_OPTIONS'];

const tocData = t => [
  {
    title: `${t(COMPLEX_PAGE_OPTIONS.TOC_TITLE.key, COMPLEX_PAGE_OPTIONS.TOC_TITLE.value)}- 1`,
    page: '03',
    isTitle: true,
  },
  {
    title: `${t(COMPLEX_PAGE_OPTIONS.TOC_SECTION.key, COMPLEX_PAGE_OPTIONS.TOC_SECTION.value)}- 1`,
    page: '03',
    isSection: true,
  },
  {
    title: `${t(
      COMPLEX_PAGE_OPTIONS.TOC_SUB_SECTION.key,
      COMPLEX_PAGE_OPTIONS.TOC_SUB_SECTION.value,
    )}- 1`,
    page: '04',
    isSubSection: true,
  },
  {
    title: `${t(
      COMPLEX_PAGE_OPTIONS.TOC_SUB_SECTION.key,
      COMPLEX_PAGE_OPTIONS.TOC_SUB_SECTION.value,
    )}- 2`,
    page: '06',
    isSubSection: true,
  },
  {
    title: `${t(COMPLEX_PAGE_OPTIONS.TOC_SECTION.key, COMPLEX_PAGE_OPTIONS.TOC_SECTION.value)}- 2`,
    page: '08',
    isSection: true,
  },
  {
    title: `${t(
      COMPLEX_PAGE_OPTIONS.TOC_SUB_SECTION.key,
      COMPLEX_PAGE_OPTIONS.TOC_SUB_SECTION.value,
    )}- 1`,
    page: '08',
    isSubSection: true,
  },
  {
    title: `${t(
      COMPLEX_PAGE_OPTIONS.TOC_SUB_SECTION.key,
      COMPLEX_PAGE_OPTIONS.TOC_SUB_SECTION.value,
    )}- 2`,
    page: '10',
    isSubSection: true,
  },
  {
    title: `${t(
      COMPLEX_PAGE_OPTIONS.TOC_SUB_SECTION.key,
      COMPLEX_PAGE_OPTIONS.TOC_SUB_SECTION.value,
    )}- 3`,
    page: '18',
    isSubSection: true,
  },
  {
    title: `${t(COMPLEX_PAGE_OPTIONS.TOC_TITLE.key, COMPLEX_PAGE_OPTIONS.TOC_TITLE.value)}- 2`,
    page: '20',
    isTitle: true,
  },
  {
    title: `${t(COMPLEX_PAGE_OPTIONS.TOC_SECTION.key, COMPLEX_PAGE_OPTIONS.TOC_SECTION.value)}- 1`,
    page: '20',
    isSection: true,
  },
  {
    title: `${t(
      COMPLEX_PAGE_OPTIONS.TOC_SUB_SECTION.key,
      COMPLEX_PAGE_OPTIONS.TOC_SUB_SECTION.value,
    )}- 1`,
    page: '21',
    isSubSection: true,
  },
  {
    title: `${t(
      COMPLEX_PAGE_OPTIONS.TOC_SUB_SECTION.key,
      COMPLEX_PAGE_OPTIONS.TOC_SUB_SECTION.value,
    )}- 2`,
    page: '24',
    isSubSection: true,
  },
  {
    title: `${t(
      COMPLEX_PAGE_OPTIONS.TOC_SUB_SECTION.key,
      COMPLEX_PAGE_OPTIONS.TOC_SUB_SECTION.value,
    )}- 3`,
    page: '27',
    isSubSection: true,
  },
];

const TocRepresentation = ({ t }) => {
  const targetRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.5 }, // Trigger when 50% of the div is visible
    );

    if (targetRef.current) {
      observer.observe(targetRef.current);
    }

    return () => {
      if (targetRef.current) {
        observer.unobserve(targetRef.current);
      }
    };
  }, []);
  return (
    <Wrapper>
      <TOCContainer ref={targetRef} isBlurred={isVisible}>
        {tocData(t).map((item, index) => (
          <TOCItem
            key={index}
            isTitle={item.isTitle}
            isSection={item.isSection}
            isSubSection={item.isSubSection}
          >
            <span>{item.title}</span>
            <Dots />
            <PageNumber isTitle={item.isTitle}>{item.page}</PageNumber>
          </TOCItem>
        ))}
      </TOCContainer>
      <Overlay visible={isVisible}>
        <OverLayContent>
          {t(COMPLEX_PAGE_OPTIONS.TOC_PLACEHOLDER.key, COMPLEX_PAGE_OPTIONS.TOC_PLACEHOLDER.value)}
        </OverLayContent>
      </Overlay>
    </Wrapper>
  );
};

export default withTranslation(NAMESPACES)(TocRepresentation);
